import { IEventType } from 'APIPackage/DictionariesModule/interfaces/IEventType';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryEventTypeSelectOption = makeCreateDictionarySelectOption<IEventType>('id', 'title');
